export default __webpack_public_path__ + "static/media/Car.70d28a6f.svg";